import { AddPopup, TagInfo, ShippingThresholdInfo } from 'types/so';
import { ProductType } from 'types/product';

/**
 * 同步 simple 购物车数据
 * @param cartInfo
 */
export const SYNC_SIMPLE_CART_INFO = '@/SYNC_SIMPLE_CART_INFO';
export const syncSimpleCartInfo = (cartInfo: any) => {
  return {
    type: SYNC_SIMPLE_CART_INFO,
    payload: cartInfo
  };
};

/**
 * 购物车外加购更细商品数量
 * @param cartInfo
 */
export const UPDATE_SIMPLE_CART = '@/UPDATE_SIMPLE_CART';
export const updateSimpleCart = (cartInfo: any) => {
  return {
    type: UPDATE_SIMPLE_CART,
    payload: cartInfo
  };
};

/**
 * 使用购物车数据同步store
 * @param cartInfo
 */
export const SYNC_CART_INFO = '@/SYNC_CART_INFO';
export const syncCartInfo = (cartInfo: any) => {
  return {
    type: SYNC_CART_INFO,
    payload: cartInfo
  };
};

/**
 * 加购物车,删除也是加购，数量为0
 * @param cartInfo
 */
export const ADD_CART = '@/ADD_CART';
export const addCart = (cartInfo: any) => {
  return {
    type: ADD_CART,
    payload: cartInfo
  };
};

/**
 * 加购物车,删除也是加购，数量为0
 * @param cartInfo
 */
export const SUB_CART = '@/SUB_CART';
export const subCart = (cartInfo: any) => {
  return {
    type: SUB_CART,
    payload: cartInfo
  };
};
/**
 * 同步提示信息
 */
export const SYNC_TAG_INGO = '@/SYNC_TAG_INGO';
export const syncTagInfo = (tagInfo: TagInfo) => {
  return {
    type: SYNC_TAG_INGO,
    payload: tagInfo
  };
};
/**
 * 同步猜你喜欢
 */
export const SYNC_MAY_LIKE = '@/SYNC_MAY_LIKE';
export const syncYouMayLike = (ymlInfo: ProductType[], ymlId: number) => {
  return {
    type: SYNC_MAY_LIKE,
    payload: {
      ymlInfo,
      ymlId
    }
  };
};

/**
 * 设置来源 referrer
 */
export const SET_REFERRER = '@/SET_REFERRER';
export const setReferrer = (payload: string) => {
  return {
    type: SET_REFERRER,
    payload: payload
  };
};

export const ADD_MULTIPLE = '@/ADD_MULTIPLE';
export const addMultiple = (cartInfo: any) => {
  return {
    type: ADD_MULTIPLE,
    payload: cartInfo
  };
};

/**
 * 设置来源 referrerType是similar还是related product
 */
export const SET_REFERRER_TYPE = '@/SET_REFERRER_TYPE';
export const setReferrerType = (payload: string) => {
  return {
    type: SET_REFERRER_TYPE,
    payload: payload
  };
};

/**
 * 凑单提示
 */
export const SYNC_ADD_POPUP = '@/SYNC_ADD_POPUP';
export const syncAddPopup = (sellerTagInfo: AddPopup) => {
  return {
    type: SYNC_ADD_POPUP,
    payload: sellerTagInfo
  };
};

export const ALL_CART_DATA = '@/ALL_CART_DATA';
export const syncAllCartData = (cartInfo: any) => {
  return {
    type: ALL_CART_DATA,
    payload: cartInfo
  };
};

/**
 * 3p弹窗提示数据
 */

export const SYNC_SHIPPING_THRESHOLD_DATA = '@/SYNC_SHIPPING_THRESHOLD_DATA';
export const SyncShippingThresholdInfo = (shippingThresholdInfo: ShippingThresholdInfo) => {
  return {
    type: SYNC_SHIPPING_THRESHOLD_DATA,
    payload: shippingThresholdInfo
  };
};

/**
 * seller float cart data
 */

export const SYNC_SELLER_CART_DATA = '@/SYNC_SELLER_CART_DATA';
export const syncSellerCartInfo = (sellerCartInfo: any) => {
  return {
    type: SYNC_SELLER_CART_DATA,
    payload: sellerCartInfo
  };
};

/**
 * all seller float cart data
 */

export const SYNC_SELLER_CARTS_DATA = '@/SYNC_SELLER_CARTS_DATA';
export const syncSellerCartsInfo = (sellerCartInfo: any[]) => {
  return {
    type: SYNC_SELLER_CARTS_DATA,
    payload: sellerCartInfo
  };
};

/**
 * 添加 修改（不包括删除商家）数量变化的时候要滚动到修改的商家到可视范围内
 */
export const SYNC_ACTIVED_VENDOR = '@/SYNC_ACTIVED_VENDOR';
export const syncActivedVendor = venderId => {
  return {
    type: SYNC_ACTIVED_VENDOR,
    payload: venderId
  };
};

/**
 * 同步simple items
 */
export const SYNC_SIMPLE_ITEMS = '@/SYNC_SIMPLE_ITEMS';
export const syncSimpleItems = items => {
  return {
    type: SYNC_SIMPLE_ITEMS,
    payload: items
  };
};
